export default __webpack_public_path__ + "static/media/pic4.5f345ac6.jpg";